import type { Slide } from '@features/powerpoint';
import type { BuildPresentationV2Props } from '../../../utils/v2/build-presentation';
import { appendixTitleSlideV2 } from '../../../../../slides/appendix/appendix-title-slide-v2';
import { glossarySlidesV2 } from '../../../../../slides/appendix/glossary/slides-v2';
import { calculationsSlidesV2 } from '../../../../../slides/appendix/calculations/slides-v2';
import { lciGuidelineMinimumsSlideV2 } from '../../../../../slides/appendix/lci-guideline-minimums/slide-v2';
import { talkToUsSlideV2 } from '../../../../../slides/appendix/talk-to-us-slide-v2';
import { howWeDoItSlideV2 } from './how-we-do-it-slide';
import { salesSummaryTableV2 } from './sales-summary-table';
import { CALCULATIONS, GLOSSARY } from '@features/glossary/subdomains/cpg';
import { MASTER_NAMES } from '../../../../../utils/shared-presentation-config-v2';
import { Calculations } from '@/features/glossary';

const salesLiftItems = CALCULATIONS.salesLift.items;

const CPG_CALCULATIONS = {
  salesLift: {
    label: 'Sales Lift',
    items: {
      incrementalSales: salesLiftItems.incrementalSales,
      incrementalSalesLift: salesLiftItems.incrementalSalesLift,
      incrementalReturnOnAdSpend: salesLiftItems.incrementalReturnOnAdSpend,
      totalProjectedSales: salesLiftItems.totalProjectedSales,
      returnOnAdSpend: salesLiftItems.returnOnAdSpend,
      salesRate: salesLiftItems.salesRate,
    },
  },
} as const satisfies Calculations;

export const appendixSlidesFromPropsV2 = (
  props: BuildPresentationV2Props
): Slide[] => {
  const { data, features } = props;

  const excludedColumns: string[] = features.cpgSalesRate ? [] : ['salesRate'];

  return props.customFields.includedSlides.appendix
    ? [
        appendixTitleSlideV2(),
        ...salesSummaryTableV2({
          slideMaster: MASTER_NAMES.titleAndContentNoLogo,
          dimensions: data.report.dimensions,
          overallReport: data.report,
          excludedColumns,
          customHeaders: Object.fromEntries(
            Object.entries(props.customFields.dimensions)
              .filter(([_, dim]) => dim.tableHeader.length > 0)
              .map(([slug, dim]) => [slug, dim.tableHeader])
          ),
        }),
        howWeDoItSlideV2(),
        lciGuidelineMinimumsSlideV2(),
        ...glossarySlidesV2({
          entriesPerColumn: [10, 8, 7, 9],
          glossary: GLOSSARY,
        }),
        ...calculationsSlidesV2(
          CPG_CALCULATIONS,
          {
            entriesPerColumnPerPage: [6],
            totalPages: 1,
          },
          { title: 'Calculations' }
        ),
        talkToUsSlideV2(),
      ]
    : [];
};
